import { render, staticRenderFns } from "./argumentLinkTable.vue?vue&type=template&id=53c22861&scoped=true"
import script from "./argumentLinkTable.vue?vue&type=script&lang=js"
export * from "./argumentLinkTable.vue?vue&type=script&lang=js"
import style0 from "./argumentLinkTable.vue?vue&type=style&index=0&id=53c22861&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c22861",
  null
  
)

export default component.exports